import { Component, Input } from "@angular/core";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";

import { SearchResultItemModel } from "../../models/search-result-item.model";

@Component({
    selector: "[pcg-ng-search-results]",
    templateUrl: "./search-results.component.html",
    providers: []
})
export class SearchResultsComponent {

    @Input()
    public results: Array<SearchResultItemModel> = [];

    @Input()
    public totalCount: number = 0;

    public readonly statuses = SearchStatus;

    @Input()
    public searchStatus: SearchStatus = SearchStatus.Loading;
}
